<template>
  <v-card class="item" height="100%" :to="to" flat tile>
    <img
      class="d-block item-img"
      :src="files + img + '?resize=1&w=600'"
      :alt="title"
    />

    <div class="pa-2 pa-md-3 pt-0 pt-md-1 item-content">
      <div class="primary--text text-body-1 text-center font-weight-medium">
        {{ title }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid var(--v-grey-lighten4);
  outline: 1px solid transparent;
  outline-offset: -1px;
  transition: all 0.1s linear;

  &-img {
    aspect-ratio: 460 / 310;
    margin-left: -1px;
    margin-right: -1px;
    margin-top: -1px;
    object-fit: cover;
    position: relative;
    width: 100%;
    width: calc(100% + 2px);
  }

  &-content {
    border-radius: 0 0 8px 8px !important;
    position: relative;

    &:before {
      background-color: #ffffff;
      border: 1px solid var(--v-grey-lighten4);
      border-bottom: 0;
      content: "";
      height: 8px;
      left: -1px;
      right: -1px;
      top: -8px;
      transition: all 0.1s linear;
      position: absolute;
    }
  }

  &:hover {
    border: 1px solid var(--v-primary-base);
    outline-offset: -2px;

    .item-content {
      &:before {
        border-bottom: 0;
      }
    }
  }
}
</style>
